import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import imgNotFound from "../../../assets/images/single-image.png";

// import "./CheckOutHotelNew.css";
import { toast } from "react-toastify";
import moment from "moment";
import { jwtDecode } from "jwt-decode";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import {
  calculateLOS,
  currentDateSingle,
  DateFormatMoment,
  formatIndianCurrency,
} from "../../../utils/utils";
import AddressAutocomplete from "../../CustomGooglePlaceAPi/AddressAutocomplete";
import GetDirectionRedirect from "../../GetDirectionRedirect/GetDirectionRedirect";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import PageMetaData from "../../PageMetaData/PageMetaData";
import { showErrorToast } from "../../../assets/toastUtils";
import styles from "./HotelCard.module.scss";
import CheckoutFooter from "../NewFooterUI/CheckoutFooter";
import PayLater from "../../PayLater/PayLater";
// import LoadAtomCheckoutScript from "../../CustomComponents/PaymentGateway/LoadAtomCheckoutScript";

function NewUICheckoutHotel() {
  const location = useLocation();
  const {
    item: selectedPlan,
    hotelData,
    ratesData,
    bookingData,
    room_id,
    hotelPolicies,
  } = location?.state || {};

  const [commission, setCommission] = useState({});
  const [openBookingDetails, setOpeBookingDetails] = useState(true);
  const [showPolicies, setShowPolicies] = useState(false);
  const [showOffers, setShowOffers] = useState(false);

  const userToken = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));

  const [propertyDiscountArray, setPropertyDiscountArray] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState([]);
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );

  const [loginWithGoogleCustomer, setLoginWithGoogleCustomer] = useState(null);
  const [hotelBookingData, setHotelBookingData] = useState(null);
  const [markupData, setMarkupData] = useState([]);
  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const [payWithAgentCredit, setPayWithAgentCredit] = useState(false);
  const [payWithAdvance, setPayWithAdvance] = useState(false);

  const handleAddressData = (data) => {
    setAddressData(data);
  };

  const [filteredData, setFilteredData] = useState(null);
  const [noOfNights, setNoOfNights] = useState("");

  // useEffect(() => {
  //   const filtered = ratesData?.rates.find((item) => item.room_id === room_id);
  //   setFilteredData(filtered);
  // }, []);

  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [bookingValues, setBookingValues] = useState({
    taxSlab: 0,
    subtotal: 0,
    taxAmount: 0,
    grandTotal: 0,
    discountAmt: 0,
    totalChildAdultCost: 0,
    agentAdvanceCalculations: 0,
    commissionAmount: 0,
  });
  const [payNow, setPayNow] = useState(false);
  const [payNowAmount, setPayNowAmount] = useState(0);
  const [PayAmount, setPayAmount] = useState(0);

  useEffect(() => {
    const filtered = ratesData?.rates?.find((item) => item.room_id === room_id);
    setFilteredData(filtered);
  }, [ratesData?.rates]);

  const [booking, setBoooking] = useState(false);
  const handleOnBooking = () => {
    setBoooking(!booking);
  };

  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, [ratesData?.rates]);

  const closePopup = () => {
    setBoooking(false);
  };

  const applyDiscount = (rate, discount) => {
    let updatedRate = rate;
    let discountAmount = 0;

    if (discount) {
      if (discount.type === "percentage") {
        // Calculate discount amount for percentage
        discountAmount = (rate * parseFloat(discount.amount)) / 100;
        updatedRate = rate;
      } else if (discount.type === "fixed") {
        // Discount amount for flat discount
        discountAmount = parseFloat(discount.amount);
        updatedRate = rate;
      }

      // Ensure updated rate is not less than zero
      updatedRate = updatedRate > 0 ? updatedRate : 0;
    }

    return {
      updatedRate: updatedRate,
      discountAmount:
        bookingData?.room !== 1 ? discountAmount : discountAmount * noOfNights,
    };
  };

  const calculateBookingValues = (
    roomRate,
    // bookingDiscount,
    // bookingDiscountType,
    selectedBookingAutomaticDiscount,
    selectedBookingDiscount,
    agentDiscount,
    agentDiscountType,
    childPricesArray,
    noOfNights,
    noOfRooms,
    agentAdvanceCalculations,
    automaticDiscounts,
    commissionAmount,
    commissionType
  ) => {
    let childPrices = childPricesArray?.reduce((accumulator, currentPrice) => {
      const parsedPrice = parseFloat(currentPrice);
      return accumulator + (isNaN(parsedPrice) ? 0 : parsedPrice);
    }, 0);

    let newRoomRate;
    let roomRatePerNight;
    let roomRateAfterDiscount;

    roomRatePerNight = roomRate;
    newRoomRate = roomRate;
    let extraAdultPrice =
      selectedPlan.extra_adult_count * selectedPlan.extra_adult;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedBookingAutomaticDiscount &&
        selectedBookingAutomaticDiscount?.length > 0 &&
        selectedBookingAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedBookingDiscount &&
        selectedBookingDiscount?.length > 0 &&
        selectedBookingDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(newRoomRate);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(newRoomRate) -
        Number(
          totalBookingAutomaticDiscountAmount
            ? totalBookingAutomaticDiscountAmount
            : 0
        )
    );

    let agentDiscountAmount = 0;
    let totalDiscountAmount =
      totalBookingAutomaticDiscountAmount + totalBookingDiscountAmount;

    if (totalDiscountAmount) {
      roomRateAfterDiscount = newRoomRate - totalDiscountAmount;
    } else {
      roomRateAfterDiscount = newRoomRate;
    }

    let roomRateParsed =
      Number(roomRateAfterDiscount) * +noOfNights * +noOfRooms;
    if (isNaN(roomRateParsed)) {
      roomRateParsed = 0;
    }

    let taxSlab;

    if (roomRateAfterDiscount) {
      taxSlab = Number(roomRateAfterDiscount) > 7500 ? 18 : 12;
    } else {
      taxSlab = +roomRateAfterDiscount > 7500 ? 18 : 12;
    }

    // let subtotal =
    //   roomRateParsed - totalDiscountAmount + (+extraAdultPrice * +noOfNights) + (+childPrices * +noOfNights);

    let subtotal =
      roomRateParsed +
      +extraAdultPrice * +noOfNights +
      +childPrices * +noOfNights;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (subtotal * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }
    if (calculatedCommissionAmount) {
      subtotal -= calculatedCommissionAmount;
    }

    let taxAmount = (subtotal * taxSlab) / 100;

    let grandTotal = subtotal + taxAmount;

    const grandTotalAfterAgentAdvance = grandTotal;
    setPayAmount(grandTotalAfterAgentAdvance);

    // if(agentAdvanceCalculations?.pay_with_advance){
    //   grandTotal -= agentAdvanceCalculations?.advanceLimit;
    // }

    // if(agentAdvanceCalculations?.pay_with_company_credit){
    //   grandTotal -= agentAdvanceCalculations?.credit_balance;
    // }

    return {
      taxSlab,
      subtotal,
      taxAmount,
      grandTotal: Math.max(grandTotal, 0),
      discountAmt: totalDiscountAmount,
      totalChildAdultCost: childPrices * +noOfNights,
      totalAdultCost: extraAdultPrice * +noOfNights,

      childPrices,
      // bookingDiscount,
      agentDiscount,
      grandTotalAfterAgentAdvance,
      roomRate: roomRateParsed,
      automaticDiscounts,
      newRoomRate,
      extraAdultPrice,
      // extraAdultPriceWithMarkup,
      // commissionRoomRate,
      calculatedCommissionAmount,
      roomRatePerNight,
      roomRateAfterDiscount,
      // agentSavingsExtraAdult,
      // childPricesWithMarkup
    };
  };

  const calculateCreditAndBalance = (
    name,
    hotelId,
    creditChecked,
    creditLimit,
    advanceChecked,
    advanceLimit,
    grandTotal,
    checkIn,
    checkOut
  ) => {
    let responseData = {
      pay_with_company_credit: creditChecked,
      pay_with_advance: advanceChecked,
      remaining_credit_balance: creditLimit,
      remaining_advance_balance: advanceLimit,
      credit_balance: creditLimit,
      advanceLimit: advanceLimit,
      checkIn: checkIn,
      checkOut: checkOut,
      grandTotal: grandTotal,
      paidAmount: 0,
      hotelId: hotelId,
      customerName: name,
      roomDetails: [],
    };

    if (creditChecked && !advanceChecked) {
      if (creditLimit > grandTotal) {
        responseData.balanceAmount = 0;
        responseData.remaining_credit_balance = creditLimit - grandTotal;
        responseData.paidAmount = grandTotal;
      } else {
        responseData.balanceAmount = grandTotal - creditLimit;
        responseData.remaining_credit_balance = 0;
        responseData.paidAmount = creditLimit;
      }
      return responseData;
    }

    if (!creditChecked && advanceChecked) {
      if (advanceLimit > grandTotal) {
        responseData.balanceAmount = 0;
        responseData.remaining_advance_balance = advanceLimit - grandTotal;
        responseData.paidAmount = grandTotal;
      } else {
        responseData.balanceAmount = grandTotal - advanceLimit;
        responseData.remaining_advance_balance = 0;
        responseData.paidAmount = advanceLimit;
      }
      return responseData;
    }

    if (creditChecked && advanceChecked) {
      let remainingAmount = grandTotal;

      if (creditLimit >= remainingAmount) {
        responseData.paidAmount = remainingAmount;
        responseData.remaining_credit_balance = creditLimit - remainingAmount;
        responseData.remaining_advance_balance = advanceLimit;
        responseData.balanceAmount = 0;
      } else {
        remainingAmount -= creditLimit;
        responseData.remaining_credit_balance = 0;
        responseData.paidAmount = creditLimit;

        if (advanceLimit >= remainingAmount) {
          responseData.paidAmount += remainingAmount;
          responseData.remaining_advance_balance =
            advanceLimit - remainingAmount;
          responseData.balanceAmount = 0;
        } else {
          responseData.paidAmount += advanceLimit;
          responseData.remaining_advance_balance = 0;
          responseData.balanceAmount = remainingAmount - advanceLimit;
        }
      }
      return responseData;
    }
    if (!creditChecked && !advanceChecked) {
      return responseData;
    }
  };

  const agentAdvanceCalculations = calculateCreditAndBalance(
    "",
    null,
    payWithAgentCredit, /// creditChecked
    userDetails?.agent_credit?.credit_amount,
    payWithAdvance, ///advanceChecked
    userDetails?.agent_advance_payment?.balance_amount,
    bookingValues.grandTotal,
    null,
    null
  );

  useEffect(() => {
    if (filteredData) {
      const roomRate = selectedPlan.rate_per_night;
      const selectedBookingAutomaticDiscount = selectedAutomaticDiscount;
      const selectedBookingDiscount = selectedDiscount;

      // const bookingDiscount = selectedDiscount?.promotionAmount;
      // const bookingDiscountType = selectedDiscount?.promotionMode;
      const agentDiscount = userDetails?.agent_category_discount || 0;
      const agentDiscountType =
        userDetails?.agent_discount_type || "percentage";
      const commissionAmount = commission?.commissionAmount;
      const commissionType = commission?.commissionType;

      const calculatedValues = calculateBookingValues(
        +selectedPlan.rate_per_night,
        // +bookingDiscount,
        // bookingDiscountType,
        selectedBookingAutomaticDiscount,
        selectedBookingDiscount,
        // selectedBookingAutomaticDiscount,
        +agentDiscount,
        agentDiscountType,
        selectedPlan.child_price,
        +noOfNights,
        +bookingData.room,
        agentAdvanceCalculations,
        hotelData?.automatic_discounts,
        commissionAmount,
        commissionType
      );

      setBookingValues(calculatedValues);
    }
  }, [
    filteredData,
    userDetails?.agent_category_discount,
    agentAdvanceCalculations?.pay_with_advance,
    agentAdvanceCalculations?.pay_with_company_credit,
    // selectedDiscount?.promotionAmount,
    // selectedDiscount?.promotionMode,
    selectedAutomaticDiscount,
    selectedDiscount,
    commission?.commissionAmount,
    commission?.commissionType,
    markupData?.markupType,
  ]);

  const [loader, setLoader] = useState(false);
  const [guestData, setGuestData] = useState({
    guest_name: "",
    guest_email: "",
    guest_phone: "",
    accommodation_notes_information: "",
    zipcode: "",
    pincode: "",
    guest_city: "",
    guest_address: "",
    gst_number: "",
    company_number: "",
    admin_email: "",
    business_email: "",
    company_address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGuestData({
      ...guestData,
      [name]: value,
    });
  };

  const handleSubmitAddress = (e) => {
    e.preventDefault();
    // Here you can send the formData to a server or save it somewhere
  };

  const guestDataHandleChange = (event) => {
    const { name, value } = event.target;
    setGuestData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!bookingData || !selectedPlan || !hotelData || !ratesData) {
      navigate("/");
    }

    const calculateNoOfNights = () => {
      if (!bookingData.checkinYear) navigate("/");
      const checkin = new Date(
        bookingData.checkinYear,
        bookingData.checkinMonth - 1,
        bookingData.checkinDay
      );
      const checkout = new Date(
        bookingData.checkoutYear,
        bookingData.checkoutMonth - 1,
        bookingData.checkoutDay
      );
      const diffTime = Math.abs(checkout - checkin);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setNoOfNights(diffDays);
    };

    // const formatDate = (year, month, day) => {
    //   return `${year}-${month}-${day}`;
    // };

    const formatDate = (year, month, day) => {
      // Ensure month and day are always two digits
      const paddedMonth = month < 10 ? `0${month}` : month;
      const paddedDay = day < 10 ? `0${day}` : day;

      return `${year}-${paddedMonth}-${paddedDay}`;
    };

    if (bookingData) {
      calculateNoOfNights();

      setCheckInDate(
        formatDate(
          bookingData.checkinYear,
          bookingData.checkinMonth,
          bookingData.checkinDay
        )
      );
      setCheckOutDate(
        formatDate(
          bookingData.checkoutYear,
          bookingData.checkoutMonth,
          bookingData.checkoutDay
        )
      );

      fetchDiscountsHandler({
        checkInDateFromBookingData: formatDate(
          bookingData.checkinYear,
          bookingData.checkinMonth,
          bookingData.checkinDay
        ),
        checkOutDateFromBookingData: formatDate(
          bookingData.checkoutYear,
          bookingData.checkoutMonth,
          bookingData.checkoutDay
        ),
      });
    }
  }, [bookingData, navigate]);

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  // const checkBookingDates = (
  //   checkinBookingDate,
  //   checkoutBookingDate,
  //   discountStartDate,
  //   discountEndDate
  // ) => {
  //   const checkin = new Date(checkinBookingDate);
  //   const checkout = new Date(checkoutBookingDate);
  //   const discountStart = new Date(discountStartDate);
  //   const discountEnd = new Date(discountEndDate);

  //   return checkin <= discountEnd && checkout >= discountStart;
  // };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];
    return checkin <= discountEnd && checkout >= discountStart;
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity.entityIds.some(
          (id) => id.toString() === currentEntityId?.toString()
        )
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = checkInDate;
      let endDate = checkOutDate;
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date();
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDateSingle);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = Number(los);
        valueToCompare = Number(conditionValue);
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      // console.log(comparisonValue === valueToCompare, 'llll');

      // console.log(startDate, 'startDate');
      // console.log(endDate, 'endDate');
      // console.log(inputDate, 'inputDate');
      // console.log(currentDate, 'currentDate');
      // console.log(comparisonValue, 'comparisonValue');
      // console.log(valueToCompare, 'valueToCompare');
      // console.log(los, 'los');

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };

    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const [propertyInfo, setPropertyInfo] = useState(false);
  const [guestDetails, setGuestDetails] = useState(true);
  const [businessProfile, setBusinessProfile] = useState(false);
  const [activePayment, setActivePayment] = useState("priceSummary");
  const [paymentDetails, setPaymentDetails] = useState(true);

  const togglePaymentDetails = () => {
    setPaymentDetails(!paymentDetails);
  };

  const handleButtonClick = () => {
    setActivePayment((prev) =>
      prev === "priceSummary" ? "priceDetails" : "priceSummary"
    );
  };

  const togglePropertyDetails = () => {
    setPropertyInfo(!propertyInfo);
  };

  const toggleGuestDetails = () => {
    setGuestDetails(!guestDetails);
  };

  const toggleBusinessProfile = () => {
    setBusinessProfile(!businessProfile);
  };

  const [cancellationPolicy, setCancellationPolicy] = useState([]);

  // const getPolicyHandler = (id) => {
  //   try {
  //     fetch(`https://extranet.travcatalyst.com/api/get-cancel-policy/${id}`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         key: process.env.REACT_APP_API_KEY,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.success) {
  //           handleOnBooking();
  //           setCancellationPolicy(data.cancelPolicy);
  //         } else {
  //           showErrorToast(data.message);
  //         }
  //       });
  //   } catch (error) { }
  // };

  const postBookingData = async (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    formdata.append("checkIn", checkInDate);
    formdata.append("checkOut", checkOutDate);
    formdata.append("adults", data.adult);
    formdata.append("child", data.children);
    formdata.append("location", data.location);
    formdata.append("rooms", data.room);
    formdata.append("PropertyType", "hotel");
    formdata.append("hotelId", data.hotelId);

    // Append childAge values dynamically
    if (data.children > 0) {
      for (let i = 1; i <= data.children; i++) {
        formdata.append(`childAge[${i - 1}]`, data.childAge[i - 1]);
      }
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_APP_URL}/api/v1/hotel-engine/check-availability`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      //   setHotelData(result.data); // Log or handle the parsed JSON response
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error state or retry logic if needed
    }
  };

  const [formData, setFormData] = useState({
    amount: bookingValues.grandTotal,
    guest_name: guestData.guest_name,
    guest_phone: guestData.guest_phone,
    guest_email: guestData.guest_email,
    pincode: guestData.pincode,
    guest_state: guestData.guest_state,
    guest_country: guestData.guest_country,
    guest_city: guestData.guest_city,
    guest_address: guestData.guest_address,
    visitDate: checkInDate,
  });

  const handleSuccessLoginWithGoogle = (response) => {
    const token = response.credential;
    const googleCustomerDetails = jwtDecode(token);
    setLoginWithGoogleCustomer(googleCustomerDetails);
  };

  useEffect(() => {
    if (loginWithGoogleCustomer) {
      handleSubmit();
    }
  }, [loginWithGoogleCustomer]);

  const [atomAccessToken, setAtomAccessToken] = useState(null);
  const [ticketData, setTicketData] = useState(null);

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setPropertyInfo(true);
      } else {
        setPropertyInfo(true);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 640) {
      setPropertyInfo(false);
    } else {
      setPropertyInfo(true);
    }
  }, []);

  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  const fetchDiscountsHandler = async ({
    checkInDateFromBookingData,
    checkOutDateFromBookingData,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPropertyDiscountArray(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";
          const isValidDate = checkDates(item.startDate, item.endDate);
          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBookingData,
            checkOutDateFromBookingData,
            item.startDate,
            item.endDate
          );
          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );
          const blackoutDates = item.promotionBlackOutDate || [];
          const isBlackout = isBlackoutDate(blackoutDates, checkInDate);
          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "hotel",
            bookingData?.hotelId
          );
          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            checkInDateFromBookingData
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];
      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      // if (applicableAutomaticPromotion) {
      setSelectedAutomaticDiscount(selectedPromotions);
      // }
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  // useEffect(() => {
  //   if (propertyDiscountArray.length > 0) {
  //     const automaticDiscount = propertyDiscountArray.find(
  //       (propertyDiscountArray) => propertyDiscountArray.promotionType === "automatic"
  //     );
  //     if (automaticDiscount) {
  //       setSelectedDiscount(automaticDiscount);
  //     }
  //   }
  // }, [propertyDiscountArray]);

  // useEffect(() => {
  //   fetchDiscountsHandler();
  // }, []);

  const isBookingWithinDiscount = checkBookingDates(
    "2024-09-24",
    "2024-09-25",
    "2024-09-24", // check-in date of booking
    "2024-09-30" // check-out date of booking
  );

  const checkRatePlans = (ratePlan, ratePlanArray) => {
    const ratePlanIds =
      ratePlanArray?.length > 0 ? ratePlanArray?.includes(ratePlan) : true;
    return ratePlanIds;
  };

  const checkRoomsExists = (ratePlan, ratePlanArray) => {
    const ratePlanIds =
      ratePlanArray?.length > 0 ? ratePlanArray?.includes(ratePlan) : true;
    return ratePlanIds;
  };

  const checkDayExists = (dayArray) => {
    const currentDay = new Date()?.getDay();

    const adjustedDay = currentDay === 0 ? 1 : currentDay + 1;
    return dayArray?.includes(adjustedDay);
  };

  const checkMinLOS = (checkin, checkout, minLOS) => {
    const checkinDate = new Date(checkin);
    const checkoutDate = new Date(checkout);

    return minLOS
      ? checkoutDate - checkinDate >= Number(minLOS) * 24 * 60 * 60 * 1000
      : true;
  };

  // const handleDiscountChange = (item) => {
  //   if (selectedDiscount?.id === item?.id) {
  //     setSelectedDiscount([]);
  //   } else {
  //     setSelectedDiscount(item);
  //   }
  // };

  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  const [formErrors, setFormErrors] = useState({});
  const validate = () => {
    const errors = {};
    if (!guestData.guest_name.trim()) {
      errors.guest_name = "required";
    }
    if (!guestData.guest_phone.trim()) {
      errors.guest_phone = "required";
    }

    if (!guestData.guest_email.trim()) {
      errors.guest_email = "is required";
    }

    if (guestData.guest_phone.trim().length < 10) {
      errors.guest_phone = "required";

      showErrorToast("Please enter valid phone number without country code.");
      // return;
      // errors.guest_phone = "required";
    }
    // if (!guestData.gst_number) {
    //   errors.gst_number = "required";
    // }
    // if (!guestData.business_email) {
    //   errors.business_email = "required";
    // }
    // if (!guestData.company_number) {
    //   errors.company_number = "required";
    // }
    // }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  // Payment Gateway
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);
  const [paymentGatewayLoader, setPaymentGatewayLoader] = useState(false);

  const fetchPaymentGateway = async () => {
    try {
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
      };
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/fetch/active`,
        {
          method: "GET",
          headers: headers,
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      setPaymentGateways(result.data);

      const firstActiveGateway = result.data.find(
        (gateway) => gateway.gatewayName === "NTTData"
      );
      if (firstActiveGateway) {
        setSelectedPaymentGateway(firstActiveGateway);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePaymentGatewayChange = (item) => {
    setSelectedPaymentGateway(item);
  };

  useEffect(() => {
    fetchPaymentGateway();
  }, []);

  const processPayment = async (bookingData) => {
    try {
      setPaymentGatewayLoader(true);
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        key: process.env.REACT_APP_BASE_API_KEY,
        Cookie: process.env.REACT_APP_COOKIE,
      };

      const body = JSON.stringify({
        order_amount: bookingData?.grandTotal,
        order_number: bookingData?.bookingNo,
        order_id: bookingData?.id,
        email: bookingData?.customerDetails?.email,
        phone: bookingData?.customerDetails?.phone,
        callbackUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${bookingData?.id}`,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/process/${selectedPaymentGateway?.gatewayName}/payment`,
        {
          method: "POST",
          headers: headers,
          body: body,
          redirect: "follow",
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      setAtomAccessToken(result?.data);
      setPaymentGatewayLoader(false);
    } catch (error) {
      console.error("Error processing payment:", error);
      setPaymentGatewayLoader(false);
    }
  };
  // New NTT UseEffect

  useEffect(() => {
    if (selectedPaymentGateway) {
      const scriptUrl = selectedPaymentGateway?.testMode
        ? "https://pgtest.atomtech.in/staticdata/ots/js/atomcheckout.js"
        : "https://psa.atomtech.in/staticdata/ots/js/atomcheckout.js";

      const existingScript = document.querySelector(
        `script[src="${scriptUrl}"]`
      );

      if (!existingScript) {
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.async = true;
        // script.onload = () => console.log("Atom Payment Gateway script loaded");
        // script.onerror = () => console.error("Failed to load Atom script");
        document.body.appendChild(script);

        // Clean up script on unmount
        return () => {
          document.body.removeChild(script);
        };
      } else if (existingScript.readyState === "complete") {
        console.log("Atom Payment Gateway script already loaded");
      }
    }
  }, [selectedPaymentGateway]);

  useEffect(() => {
    if (
      atomAccessToken &&
      hotelBookingData &&
      typeof window.AtomPaynetz !== "undefined"
    ) {
      const options = {
        merchId: process.env.REACT_APP_ATOM_MERCHANT_ID, // Use your merchant ID
        atomTokenId: atomAccessToken,
        custEmail: hotelBookingData?.customerDetails?.email,
        custMobile: hotelBookingData?.customerDetails?.phone,
        returnUrl: `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${hotelBookingData?.id}`,
      };

      const atom = new window.AtomPaynetz(options, "uat");

      const handlePaymentClick = (e) => {
        e.preventDefault(); // Prevent default action

        try {
          atom.invoke((status) => {
            if (status === "success") {
              // Navigate to ThankYou component on succ ess
              navigate("/thank-you", {
                state: { bookingId: hotelBookingData?.id }, // Pass data if needed
              });
            } else if (status === "failure" || status === "cancel") {
              // Handle failure or cancellation
              toast.error("Payment failed. Please try again.");
              navigate("/cancel", {
                state: { bookingId: hotelBookingData?.id },
              });
            } else {
              toast.error("Unknown payment status. Please contact support.");
            }
          });
        } catch (err) {
          console.error("Error initiating payment", err);
          toast.error("Failed to initiate payment. Please try again.");
        }
      };

      const paymentButton = document.querySelector("#paymentButton");
      if (paymentButton) {
        paymentButton.addEventListener("click", handlePaymentClick);
      }

      // Clean up event listener on unmount
      return () => {
        if (paymentButton) {
          paymentButton.removeEventListener("click", handlePaymentClick);
        }
      };
    } else {
      console.warn("AtomPaynetz is not ready or required data is missing");
    }
  }, [atomAccessToken, hotelBookingData, selectedPaymentGateway, navigate]);

  const handleMessage = async ({ data }) => {
    if (data === "cancelTransaction") {
      try {
        const headers = {
          Accept: "application/json",
          "Content-Type": "application/json",
          key: process.env.REACT_APP_BASE_API_KEY,
          Cookie: process.env.REACT_APP_COOKIE,
        };
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/v1/website/payment-gateway/payment/${selectedPaymentGateway?.gatewayName}/response/${hotelBookingData?.id}`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              encData: "",
              order_id: hotelBookingData?.id,
              status: "cancelled",
            }),
          }
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const result = await response.json();
        navigate(
          `/thank-you?paymentGateway=${selectedPaymentGateway?.gatewayName}&bookingId=${hotelBookingData?.id}&status=cancelled`
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  // commission api
  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/accommodation/${hotelData?.hotelInfo?.id}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (userType === "agent") {
      fetchCommissions();
    }
  }, [userType]);

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [hotelBookingData]);

  const handleSubmit = async () => {
    if (bookingValues?.grandTotal <= 0) {
      showErrorToast(`This room can not be booked`);
      return;
    }
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      key: process.env.REACT_APP_BASE_API_KEY,
      Cookie: process.env.REACT_APP_COOKIE,
    };

    const automaticDiscountToSend = (selectedAutomaticDiscount || []).map(
      (item) => ({
        rate: item?.promotionMode || "",
        amount: item?.promotionAmount || 0,
      })
    );

    const selectedDiscountToSend = (selectedDiscount || []).map((item) => ({
      rate: item?.promotionMode || "",
      amount: item?.promotionAmount || 0,
    }));

    const body = JSON.stringify({
      booking_type: "accommodation",
      customer_type: userType === "agent" ? "agent" : "customer",
      customer_name: guestData?.guest_name,
      customer_email: guestData?.guest_email,
      customer_phone: guestData?.guest_phone,
      customer_address: addressData?.address,
      customer_country: addressData?.country,
      customer_state: addressData?.state,
      customer_city: addressData?.city,
      customer_zipcode: guestData?.zipcode,
      total: bookingValues?.subtotal,
      grand_total: bookingValues?.grandTotal,
      status: "hold",
      accommodation_notes_information:
        guestData?.accommodation_notes_information,
      misc_details: [],
      markup_details: [],
      tax_details: [
        { rate: bookingValues?.taxSlab, amount: bookingValues?.taxAmount },
      ],
      discount_details_information: [
        ...(automaticDiscountToSend || []),
        ...(selectedDiscountToSend || []),
      ],
      accommodations: [
        {
          accommodation_id: Number(bookingData?.hotelId),
          supplier_id: hotelData?.hotelInfo?.supplier_id,
          room_id: Number(room_id),
          name: hotelData?.hotelInfo?.name,
          destination: bookingData.location ? bookingData.location : "",
          hotel_category: hotelData?.hotelInfo?.category,
          star_rating: hotelData?.hotelInfo?.star_rating
            ? hotelData?.hotelInfo?.star_rating
            : "",
          room_type: ratesData?.room_name,
          meal_plan: selectedPlan.meal_plan ? selectedPlan.meal_plan : "ep",
          rateplan_id: selectedPlan.rate_plan_id
            ? selectedPlan.rate_plan_id
            : "",
          rooms: bookingData.room ? bookingData.room : "1",
          nights: noOfNights,
          adults: bookingData.adult ? Number(bookingData.adult) : "",
          extra_adult: selectedPlan?.extra_adult_count,
          child_w_bed: selectedPlan?.childWithBed
            ? selectedPlan?.childWithBed
            : 0,
          child_wo_bed: selectedPlan?.childWithoutBed
            ? selectedPlan?.childWithoutBed
            : 0,
          extra_adult_cost: selectedPlan?.extra_adult,
          child_w_bed_cost: selectedPlan?.childWithoutBedCost
            ? selectedPlan?.childWithoutBedCost
            : 0,
          child_wo_bed_cost: selectedPlan?.childWithoutBedCost
            ? selectedPlan?.childWithoutBedCost
            : 0,
          room_cost: selectedPlan.rate_per_night,
          adhoc: false,
          check_in: checkInDate,
          check_out: checkOutDate,
        },
      ],
      addons: [],
    });

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/booking/create`,
        {
          method: "POST",
          headers,
          body,
          redirect: "follow",
        }
      );

      const result = await response.json();
      if (result.success) {
        setHotelBookingData(result.data);
        processPayment(result.data);
      } else {
        showErrorToast(result.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // console.log(selectedDiscount, "selectedDiscount")
  // console.log(bookingData, 'bookingData');
  // console.log(bookingValues, 'bookingValues');

  const childAgesForPriceBreakup = bookingData?.childAge?.map((age) =>
    parseInt(age, 12)
  );
  const complimentaryChildren = childAgesForPriceBreakup?.filter(
    (age) => age < 6
  ).length;
  const extraChildrenForPricebreakup =
    bookingData?.children - complimentaryChildren;

  return (
    <>
      {/* <LoadAtomCheckoutScript onScriptLoad={handleScriptLoad} /> */}
      <div id="checkOutHotels">
        <PageMetaData
          title="Mountain Mysteries"
          description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
          keywords="hotel management, RevCatalyst, property optimization"
        />
        <NewUiHeader />
        {/* <PageLinks links={["Home", `Properties In ${bookingData.location}`, `${bookingData.hotel_name}`]} /> */}
        <section className={styles.section_with_background}>
          <div className="container">
            <div className={styles.flex_main}>
              <div className={styles.reservation_content}>
                {/* <div className="list_details" id="padding">
                                    <div
                                        className="flex justify_content_between cursor_pointer align_items_center"
                                        onClick={togglePropertyDetails}
                                    >
                                        <h5 className="text-left pb_10">PROPERTY INFO</h5>
                                        <svg
                                            width="13"
                                            height="8"
                                            viewBox="0 0 13 8"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            style={{
                                                transition: "transform 0.3s",
                                                transform: propertyInfo
                                                    ? "rotate(180deg)"
                                                    : "rotate(0deg)",
                                            }}
                                        >
                                            <path
                                                d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                                stroke="#222222"
                                                strokeWidth="1.5"
                                            />
                                        </svg>
                                    </div>
                                    {propertyInfo && (
                                        <>
                                            <div className="hotel-data mt-10">
                                                <div className="hotel_img">
                                                    {hotelData?.hotelImages &&
                                                        hotelData?.hotelImages.length > 0 ? (
                                                        <img
                                                            src={hotelData?.hotelImages[0]}
                                                            alt="hotel-room-image"
                                                            style={{ height: '180px' }}
                                                        />
                                                    ) : (
                                                        <img src={imgNotFound} alt="image not found" />
                                                    )}
                                                </div>
                                                <div className="hotel-text">
                                                    <h6>
                                                        <b>{hotelData?.hotelInfo?.name}</b>
                                                    </h6>
                                                    <span>{hotelData?.hotelInfo?.star_rating} Star</span>
                                                    <GetDirectionRedirect
                                                        address={hotelData?.hotelInfo?.address}
                                                    >
                                                        <small>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                viewBox="0 0 16 16"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M4.83301 6.66667C4.83301 5.82681 5.16664 5.02136 5.7605 4.4275C6.35437 3.83363 7.15982 3.5 7.99967 3.5C8.83953 3.5 9.64498 3.83363 10.2388 4.4275C10.8327 5.02136 11.1663 5.82681 11.1663 6.66667C11.1663 7.50652 10.8327 8.31197 10.2388 8.90584C9.64498 9.4997 8.83953 9.83333 7.99967 9.83333C7.15982 9.83333 6.35437 9.4997 5.7605 8.90584C5.16664 8.31197 4.83301 7.50652 4.83301 6.66667ZM7.99967 4.5C7.42504 4.5 6.87394 4.72827 6.46761 5.1346C6.06128 5.54093 5.83301 6.09203 5.83301 6.66667C5.83301 7.2413 6.06128 7.7924 6.46761 8.19873C6.87394 8.60506 7.42504 8.83333 7.99967 8.83333C8.57431 8.83333 9.12541 8.60506 9.53174 8.19873C9.93807 7.7924 10.1663 7.2413 10.1663 6.66667C10.1663 6.09203 9.93807 5.54093 9.53174 5.1346C9.12541 4.72827 8.57431 4.5 7.99967 4.5Z"
                                                                    fill="#888888"
                                                                />
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M2.34926 5.90471C2.46321 4.52258 3.09274 3.23383 4.11287 2.29436C5.13299 1.35488 6.4691 0.83337 7.85593 0.833374H8.14393C9.53075 0.83337 10.8669 1.35488 11.887 2.29436C12.9071 3.23383 13.5366 4.52258 13.6506 5.90471C13.7774 7.44423 13.3018 8.97288 12.3239 10.1687L9.12859 14.076C8.99185 14.2433 8.81965 14.378 8.62445 14.4705C8.42926 14.5631 8.21594 14.6111 7.99993 14.6111C7.78391 14.6111 7.57059 14.5631 7.3754 14.4705C7.1802 14.378 7.00801 14.2433 6.87126 14.076L3.67593 10.1687C2.698 8.97292 2.22238 7.44424 2.34926 5.90471ZM7.85593 1.83337C6.72025 1.83355 5.62615 2.26073 4.79081 3.03012C3.95546 3.79952 3.43995 4.85487 3.34659 5.98671C3.24099 7.26795 3.63678 8.54016 4.45059 9.53537L7.64593 13.4434C7.68888 13.4959 7.74298 13.5383 7.80432 13.5674C7.86566 13.5965 7.9327 13.6116 8.00059 13.6116C8.06848 13.6116 8.13552 13.5965 8.19686 13.5674C8.2582 13.5383 8.3123 13.4959 8.35526 13.4434L11.5506 9.53537C12.3639 8.53997 12.7592 7.26777 12.6533 5.98671C12.5599 4.85476 12.0443 3.79931 11.2088 3.02989C10.3733 2.26048 9.27905 1.83338 8.14326 1.83337H7.85526H7.85593Z"
                                                                    fill="#888888"
                                                                />
                                                            </svg>{" "}
                                                            {hotelData?.hotelInfo?.address}
                                                        </small>
                                                    </GetDirectionRedirect>
                                                    <br />
                                                    <p className="hotel-description">
                                                        {hotelData?.hotelInfo?.details}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex_align_center Checkouthotel-main flex_gap_20">
                                                <div className="Checkouthotel-dates flex_align_center justify_content_between w-half mt-10">
                                                    <div className="">
                                                        <span>Check in</span>
                                                        <h6 className="">
                                                            {moment(checkInDate).format("MMM Do YYYY")}
                                                        </h6>
                                                    </div>
                                                    <div className=" Checkouthotel-checkout">
                                                        <span>Check Out</span>
                                                        <h6>
                                                            {" "}
                                                            {moment(checkOutDate).format("MMM Do YYYY")}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="guestDetailsData mt-20">
                                                <h5 className="text-left p_10 border-bottom-one">
                                                    {bookingData?.room} Room , {bookingData?.adult}{" "}
                                                    Adults,
                                                    {bookingData?.children && (
                                                        <span> {bookingData?.children} Child</span>
                                                    )}
                                                </h5>
                                                <div className="room_details p_10">
                                                    <div className="border-right-one" id="right-border-0">
                                                        <div>
                                                            <h6>
                                                                {" "}
                                                                {bookingData?.room} x {ratesData?.room_name}
                                                            </h6>
                                                        </div>
                                                        <div className="mt-10 ">
                                                            <span>
                                                                {bookingData?.adult} Adults,
                                                                {bookingData?.children && (
                                                                    <span> {bookingData?.children} Child</span>
                                                                )}{" "}
                                                                <small>
                                                                    {" "}
                                                                    ({selectedPlan?.meal_plan_name}){" "}
                                                                </small>
                                                            </span>
                                                            <div
                                                                className="link_btn mt-10 cursor_pointer"
                                                                onClick={() =>
                                                                    setBoooking(!booking)
                                                                }
                                                            >
                                                                <b>Cancellation Policy</b>
                                                            </div>
                                                            {booking && (
                                                                <section className="popup_backdrop">
                                                                    <div className="cancellation_content" style={{ height: 'max-content' }}>
                                                                        <div className="close_svg">
                                                                            <svg
                                                                                width="14"
                                                                                height="14"
                                                                                viewBox="0 0 14 14"
                                                                                fill="none"
                                                                                onClick={closePopup}
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M1 13L13 1"
                                                                                    stroke="#AAAAAA"
                                                                                    strokeWidth="1.2"
                                                                                />
                                                                                <path
                                                                                    d="M13 13L1 1"
                                                                                    stroke="#AAAAAA"
                                                                                    strokeWidth="1.2"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                        <div className="container">
                                                                            <div className="overview-content mt-20">
                                                                                <h5>Cancellation policy</h5>
                                                                                <div
                                                                                    className="cancellation_policy"
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: hotelPolicies?.[0]?.cancellation || "<p>No cancellation policy available.</p>",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </section>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div> */}
                <div className={styles.list_details}>
                  <div
                    className="flex justify_content_between align_items_center cursor_pointer "
                    style={{ padding: "15px" }}
                  >
                    <h4 className="text-left">Guest Details</h4>
                  </div>
                  <form action="" style={{ padding: "0 15px 15px 15px" }}>
                    <div className={styles.form_data}>
                      <div>
                        <div>
                          <label htmlFor="">Full Name</label>
                          <input
                            className="HotelCheckout-Input"
                            id="guest_name"
                            type="text"
                            name="guest_name"
                            value={guestData.guest_name}
                            onChange={guestDataHandleChange}
                            required
                            placeholder="Enter full name"
                          />
                        </div>
                      </div>
                      <div className="input-flex mt-10">
                        <div className="CheckoutHotel-Fields">
                          <div className="flex align_items_center flex_gap_5">
                            {" "}
                            <label htmlFor="">Email Address </label>
                            <svg
                              width="12"
                              height="13"
                              viewBox="0 0 12 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.66667 9.5H6.33333V5.83333H5.66667V9.5ZM6 4.88467C6.11622 4.88467 6.21367 4.84533 6.29233 4.76667C6.371 4.688 6.41033 4.59056 6.41033 4.47433C6.41033 4.35811 6.371 4.26067 6.29233 4.182C6.21367 4.10344 6.11622 4.06417 6 4.06417C5.88378 4.06417 5.78633 4.10344 5.70767 4.182C5.629 4.26067 5.58967 4.35811 5.58967 4.47433C5.58967 4.59056 5.629 4.688 5.70767 4.76667C5.78633 4.84533 5.88378 4.88467 6 4.88467ZM6.00217 12.5C5.1725 12.5 4.39244 12.3426 3.662 12.0277C2.93167 11.7128 2.29633 11.2854 1.756 10.7457C1.21567 10.2059 0.787944 9.57111 0.472833 8.84133C0.157611 8.11167 0 7.33194 0 6.50217C0 5.6725 0.157444 4.89244 0.472333 4.162C0.787222 3.43167 1.21456 2.79633 1.75433 2.256C2.29411 1.71567 2.92889 1.28794 3.65867 0.972833C4.38833 0.657611 5.16806 0.5 5.99783 0.5C6.8275 0.5 7.60756 0.657445 8.338 0.972334C9.06833 1.28722 9.70367 1.71456 10.244 2.25433C10.7843 2.79411 11.2121 3.42889 11.5272 4.15867C11.8424 4.88833 12 5.66806 12 6.49783C12 7.3275 11.8426 8.10756 11.5277 8.838C11.2128 9.56833 10.7854 10.2037 10.2457 10.744C9.70589 11.2843 9.07111 11.7121 8.34133 12.0272C7.61167 12.3424 6.83194 12.5 6.00217 12.5ZM6 11.8333C7.48889 11.8333 8.75 11.3167 9.78333 10.2833C10.8167 9.25 11.3333 7.98889 11.3333 6.5C11.3333 5.01111 10.8167 3.75 9.78333 2.71667C8.75 1.68333 7.48889 1.16667 6 1.16667C4.51111 1.16667 3.25 1.68333 2.21667 2.71667C1.18333 3.75 0.666667 5.01111 0.666667 6.5C0.666667 7.98889 1.18333 9.25 2.21667 10.2833C3.25 11.3167 4.51111 11.8333 6 11.8333Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </div>

                          <input
                            className="HotelCheckout-Input"
                            id="guest_email"
                            name="guest_email"
                            value={guestData.guest_email}
                            onChange={guestDataHandleChange}
                            required
                            placeholder="Enter email address"
                          />
                        </div>

                        <div className="CheckoutHotel-Fields">
                          <div className="flex align_items_center flex_gap_5">
                            <label htmlFor="">Phone</label>{" "}
                            <svg
                              width="12"
                              height="13"
                              viewBox="0 0 12 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.66667 9.5H6.33333V5.83333H5.66667V9.5ZM6 4.88467C6.11622 4.88467 6.21367 4.84533 6.29233 4.76667C6.371 4.688 6.41033 4.59056 6.41033 4.47433C6.41033 4.35811 6.371 4.26067 6.29233 4.182C6.21367 4.10344 6.11622 4.06417 6 4.06417C5.88378 4.06417 5.78633 4.10344 5.70767 4.182C5.629 4.26067 5.58967 4.35811 5.58967 4.47433C5.58967 4.59056 5.629 4.688 5.70767 4.76667C5.78633 4.84533 5.88378 4.88467 6 4.88467ZM6.00217 12.5C5.1725 12.5 4.39244 12.3426 3.662 12.0277C2.93167 11.7128 2.29633 11.2854 1.756 10.7457C1.21567 10.2059 0.787944 9.57111 0.472833 8.84133C0.157611 8.11167 0 7.33194 0 6.50217C0 5.6725 0.157444 4.89244 0.472333 4.162C0.787222 3.43167 1.21456 2.79633 1.75433 2.256C2.29411 1.71567 2.92889 1.28794 3.65867 0.972833C4.38833 0.657611 5.16806 0.5 5.99783 0.5C6.8275 0.5 7.60756 0.657445 8.338 0.972334C9.06833 1.28722 9.70367 1.71456 10.244 2.25433C10.7843 2.79411 11.2121 3.42889 11.5272 4.15867C11.8424 4.88833 12 5.66806 12 6.49783C12 7.3275 11.8426 8.10756 11.5277 8.838C11.2128 9.56833 10.7854 10.2037 10.2457 10.744C9.70589 11.2843 9.07111 11.7121 8.34133 12.0272C7.61167 12.3424 6.83194 12.5 6.00217 12.5ZM6 11.8333C7.48889 11.8333 8.75 11.3167 9.78333 10.2833C10.8167 9.25 11.3333 7.98889 11.3333 6.5C11.3333 5.01111 10.8167 3.75 9.78333 2.71667C8.75 1.68333 7.48889 1.16667 6 1.16667C4.51111 1.16667 3.25 1.68333 2.21667 2.71667C1.18333 3.75 0.666667 5.01111 0.666667 6.5C0.666667 7.98889 1.18333 9.25 2.21667 10.2833C3.25 11.3167 4.51111 11.8333 6 11.8333Z"
                                fill="#1C1B1F"
                              />
                            </svg>
                          </div>
                          <input
                            className="HotelCheckout-Input"
                            type="number"
                            id="guest_phone"
                            name="guest_phone"
                            value={guestData.guest_phone}
                            onChange={guestDataHandleChange}
                            required
                            placeholder="Enter phone number"
                          />
                        </div>
                        <div className="CheckoutHotel-Fields w-half">
                          <label htmlFor="">Zipcode</label>
                          <input
                            className="HotelCheckout-Input"
                            type="number"
                            id="zipcode"
                            name="zipcode"
                            value={guestData.zipcode}
                            onChange={guestDataHandleChange}
                            placeholder="Zipcode"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className={styles.list_details}>
                  <div
                    className="flex justify_content_between align_items_center cursor_pointer"
                    style={{ padding: "15px" }}
                  >
                    <h4 className="text-left">Guest Address</h4>
                  </div>

                  <form action="" style={{ padding: "0 15px 15px 15px" }}>
                    <div className={styles.form_data}>
                      <div>
                        <label htmlFor="address">Address</label>
                        <AddressAutocomplete
                          formdata={formData}
                          onAddressChange={handleAddressData}
                        />
                      </div>

                      <div className="mt-10">
                        <label htmlFor="accommodation_notes_information">
                          Additional Details
                        </label>
                        <textarea
                          className="HotelCheckout-Input mt-5"
                          id="accommodation_notes_information"
                          name="accommodation_notes_information"
                          value={guestData.accommodation_notes_information}
                          onChange={guestDataHandleChange}
                          required
                          placeholder="Additional Details"
                        />
                      </div>
                    </div>
                  </form>
                </div>

                <div className={styles.list_details}>
                  <div
                    className="flex justify_content_between align_items_center cursor_pointer "
                    style={{ padding: "15px" }}
                    onClick={() => setOpeBookingDetails(!openBookingDetails)}
                  >
                    <h4>Booking Details</h4>
                    <svg
                      width="13"
                      height="8"
                      viewBox="0 0 13 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transition: "transform 0.4s",
                        transform: openBookingDetails
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    >
                      <path
                        d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                        stroke="#222222"
                        strokeWidth="1.5"
                      />
                    </svg>
                  </div>

                  {openBookingDetails && (
                    <div style={{ padding: "0 15px 15px 15px" }}>
                      <div className={styles.booking_data_hotels}>
                        <div className={styles.booking_data_flex}>
                          {hotelData?.hotelImages?.length > 0 ? (
                            <img
                              src={hotelData?.hotelImages[0]}
                              alt="hotel-image"
                            />
                          ) : (
                            <img src={imgNotFound} alt="Image not found" />
                          )}
                          <div className={styles.content_sec}>
                            <div className={styles.rating}>
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7 0.5L8.5716 5.33688H13.6574L9.5429 8.32624L11.1145 13.1631L7 10.1738L2.8855 13.1631L4.4571 8.32624L0.342604 5.33688H5.4284L7 0.5Z"
                                  fill="#ECB119"
                                />
                              </svg>
                              {hotelData?.hotelInfo?.star_rating
                                ? Number(hotelData?.hotelInfo?.star_rating)
                                : 0}{" "}
                              Star
                            </div>
                            <h5>{hotelData?.hotelInfo?.name}</h5>
                            <small className="flex  align_items_center">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5983_7301"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="20"
                                  height="20"
                                >
                                  <rect width="20" height="20" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_5983_7301)">
                                  <path
                                    d="M9.0013 8.89894C9.37443 8.89894 9.69343 8.76606 9.9583 8.50031C10.2233 8.23456 10.3558 7.91512 10.3558 7.542C10.3558 7.16887 10.2229 6.84981 9.95718 6.58481C9.69143 6.31994 9.37193 6.1875 8.99868 6.1875C8.62555 6.1875 8.30655 6.32038 8.04168 6.58613C7.77668 6.85188 7.64418 7.17138 7.64418 7.54463C7.64418 7.91775 7.77705 8.23675 8.0428 8.50163C8.30855 8.7665 8.62805 8.89894 9.0013 8.89894ZM8.99999 14.6351C10.4672 13.3216 11.5901 12.0618 12.3684 10.8555C13.1468 9.64925 13.536 8.59275 13.536 7.686C13.536 6.31875 13.1016 5.19475 12.2329 4.314C11.3641 3.43325 10.2865 2.99287 8.99999 2.99287C7.71349 2.99287 6.63586 3.43325 5.76711 4.314C4.89836 5.19475 4.46399 6.31875 4.46399 7.686C4.46399 8.59275 4.85318 9.64925 5.63155 10.8555C6.40993 12.0618 7.53274 13.3216 8.99999 14.6351ZM8.99999 16.1321C7.11249 14.4966 5.69711 12.9746 4.75386 11.5659C3.81061 10.1572 3.33899 8.86387 3.33899 7.686C3.33899 5.95525 3.8988 4.55406 5.01843 3.48244C6.13818 2.41081 7.46536 1.875 8.99999 1.875C10.5346 1.875 11.8618 2.41081 12.9816 3.48244C14.1012 4.55406 14.661 5.95525 14.661 7.686C14.661 8.86387 14.1894 10.1572 13.2461 11.5659C12.3029 12.9746 10.8875 14.4966 8.99999 16.1321Z"
                                    fill="#888888"
                                  />
                                </g>
                              </svg>
                              {hotelData?.hotelInfo?.address}
                            </small>
                          </div>
                        </div>
                        <div className={styles.time_slot}>
                          <div>
                            <small>check in</small>
                            <span>
                              {moment(checkInDate).format("MMM Do YYYY")}
                            </span>
                          </div>
                          <div>
                            <small>check out</small>
                            <span>
                              {moment(checkOutDate).format("MMM Do YYYY")}
                            </span>
                          </div>
                          <div>
                            {" "}
                            <small>aDULTS & ROOMS</small>
                            <span>
                              {bookingData?.room} Room, {bookingData?.adult}{" "}
                              Adults
                              {bookingData?.children
                                ? `, ${bookingData.children} Child`
                                : ""}
                            </span>
                          </div>
                        </div>
                        <div className={styles.booking_details}>
                          <div>
                            <span>Room & Meal Plan</span>
                            <ul>
                              <li>
                                {bookingData?.room} x {ratesData?.room_name}
                              </li>
                              <li>{selectedPlan?.meal_plan_name}</li>
                            </ul>
                          </div>
                          <div className={styles.policies}>
                            <div>
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_5985_9337"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="16"
                                  height="16"
                                >
                                  <rect width="16" height="16" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_5985_9337)">
                                  <path
                                    d="M6.36641 12.0003L2.56641 8.20031L3.51641 7.25031L6.36641 10.1003L12.4831 3.98364L13.4331 4.93364L6.36641 12.0003Z"
                                    fill="#009A50"
                                  />
                                </g>
                              </svg>
                              Free Cancellation before 7 days
                            </div>
                            {hotelData?.hotelInfo?.hotel_policies &&
                              hotelData?.hotelInfo?.hotel_policies.length >
                                0 && (
                                <div>
                                  {hotelData?.hotelInfo?.hotel_policies.map(
                                    (item, index) =>
                                      item?.cancellation ? ( // Check if "cancellation" key exists
                                        <div key={index}>
                                          <button
                                            onClick={() =>
                                              setShowPolicies(item.cancellation)
                                            } // Pass cancellation policy content
                                            className={styles.know_more}
                                          >
                                            Know More
                                          </button>
                                        </div>
                                      ) : null
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                        {showPolicies && (
                          <div className="bg-backdrop">
                            <div className="bg-white activity-legals">
                              <div className="flex justify_content_between align_items_center">
                                <h5>Cancellation Policy</h5>
                                <svg
                                  onClick={() => setShowPolicies(null)}
                                  width="14"
                                  height="13"
                                  viewBox="0 0 14 13"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1 12.5L13 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                  <path
                                    d="M13 12.5L1 0.5"
                                    stroke="#AAAAAA"
                                    strokeWidth="1.2"
                                  />
                                </svg>
                              </div>
                              <div className="policy_content mt-10">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: showPolicies,
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  {paymentGateways.length > 0 ? (
                    <>
                      <div className={styles.buttons}>
                        <h4>Payment gateway</h4>
                        {paymentGateways &&
                          paymentGateways.map((item, index) => (
                            <>
                              <div
                                key={index}
                                className="flex discountSingleDiv justify_content_between w-100"
                              >
                                <div className="flex">
                                  <label
                                    style={{
                                      textTransform: "capitalize",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    htmlFor={item?.gatewayName}
                                  >
                                    <input
                                      checked={
                                        selectedPaymentGateway?.gatewayName ===
                                        item?.gatewayName
                                      }
                                      onChange={() =>
                                        handlePaymentGatewayChange(item)
                                      }
                                      type="radio"
                                      id={item?.gatewayName}
                                    />
                                    <div style={{ cursor: "pointer" }}>
                                      <div>{item.gatewayName}</div>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                      {/* <PayLater
                        setPayNow={setPayNow}
                        setPayNowAmount={setPayNowAmount}
                        PayAmount={PayAmount}
                        payNow={payNow}
                      /> */}
                      <div className={styles.buttons}>
                        <button
                          style={{ marginTop: "10px" }}
                          // disabled
                          onClick={handleSubmit}
                          className={styles.book_btn}
                        >
                          Proceed to Payment
                          <svg
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_6067_16102"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="17"
                              height="17"
                            >
                              <rect
                                x="0.5"
                                y="0.5"
                                width="16"
                                height="16"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_6067_16102)">
                              <path
                                d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className={styles.buttons}>
                      <button
                        style={{ marginTop: "10px", cursor: "not-allowed" }}
                        // onClick={bookPackageHandle}
                        disabled={true}
                        className={styles.book_btn}
                      >
                        Proceed to Payment
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_6067_16102"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="17"
                            height="17"
                          >
                            <rect
                              x="0.5"
                              y="0.5"
                              width="16"
                              height="16"
                              fill="#D9D9D9"
                            />
                          </mask>
                          <g mask="url(#mask0_6067_16102)">
                            <path
                              d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.right_price_breakup}>
                {propertyDiscountArray.length > 0 && (
                  <>
                    {propertyDiscountArray.some(
                      (item) =>
                        item.promotionType === "coupon" &&
                        (() => {
                          const isValidDate = checkDates(
                            item.startDate,
                            item.endDate
                          );

                          const isBookingWithinDiscount = checkBookingDates(
                            checkInDate,
                            checkInDate,
                            item.startDate,
                            item.endDate
                          );

                          const isUserEligible = isPromotionApplicable(
                            userType === "customer"
                              ? "customers"
                              : userType === "agent"
                              ? "agents"
                              : "",
                            userDetails?.id,
                            item.promotionApplicable
                          );

                          const blackoutDates =
                            item.promotionBlackOutDate || [];
                          const isBlackout = isBlackoutDate(
                            blackoutDates,
                            checkInDate
                          );
                          const isApplicableForEntity =
                            isPromotionApplicableForEntity(
                              item.promotionEntity,
                              "hotel",
                              bookingData?.hotelId
                            );
                          const isConditionsValid = evaluateConditions(
                            item.promotionConditions,
                            checkInDate
                          );

                          return (
                            isValidDate &&
                            isBookingWithinDiscount &&
                            isUserEligible &&
                            !isBlackout &&
                            isApplicableForEntity &&
                            isConditionsValid
                          );
                        })()
                    ) && (
                      <div
                        className="discount_new_ui"
                        style={{
                          background: showOffers ? "#FFFCF3" : "#FFFFFF",
                        }}
                      >
                        <div className="flex justify_content_between cursor_pointer">
                          <div
                            className="flex justify_content_between w-100 mb-10"
                            onClick={() => setShowOffers(!showOffers)}
                          >
                            <div>
                              <h5 className="text-left">Offers</h5>
                            </div>
                            <button>
                              <svg
                                width="13"
                                height="8"
                                viewBox="0 0 13 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  transition: "transform 0.3s",
                                  transform: showOffers
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                }}
                              >
                                <path
                                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                  stroke="#222222"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        {showOffers && (
                          <div>
                            {propertyDiscountArray.map((item, index) => {
                              const isCouponCode =
                                item?.promotionType === "coupon" ? true : false;

                              const isValidDate = checkDates(
                                item.startDate,
                                item.endDate
                              );

                              const isBookingWithinDiscount = checkBookingDates(
                                checkInDate,
                                checkInDate,
                                item.startDate,
                                item.endDate
                              );

                              const isUserEligible = isPromotionApplicable(
                                userType === "customer"
                                  ? "customers"
                                  : userType === "agent"
                                  ? "agents"
                                  : "",
                                userDetails?.id,
                                item.promotionApplicable
                              );

                              const blackoutDates =
                                item.promotionBlackOutDate || [];
                              const isBlackout = isBlackoutDate(
                                blackoutDates,
                                checkInDate
                              );
                              const isApplicableForEntity =
                                isPromotionApplicableForEntity(
                                  item.promotionEntity,
                                  "hotel",
                                  bookingData?.hotelId
                                );
                              const isConditionsValid = evaluateConditions(
                                item.promotionConditions,
                                checkInDate
                              );

                              return (
                                isCouponCode &&
                                isValidDate &&
                                isBookingWithinDiscount &&
                                isUserEligible &&
                                !isBlackout &&
                                isApplicableForEntity &&
                                isConditionsValid && (
                                  <div
                                    key={index}
                                    className="flex discount_new_ui_item justify_content_between w-100"
                                    style={{
                                      backgroundColor: selectedDiscount?.some(
                                        (discount) => discount.id === item.id
                                      )
                                        ? "#E8F9F1"
                                        : "transparent",
                                      border: selectedDiscount?.some(
                                        (discount) => discount.id === item.id
                                      )
                                        ? "0.5px solid #E8F9F1"
                                        : "0.5px solid #cccccc7c",
                                    }}
                                  >
                                    <div className="flex">
                                      <label
                                        style={{
                                          textTransform: "capitalize",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          textTransform: "uppercase",
                                          cursor: "pointer",
                                        }}
                                        htmlFor={item?.promotionName}
                                      >
                                        {" "}
                                        <input
                                          // checked={
                                          //   selectedDiscount?.id === item?.id
                                          // }
                                          // onChange={() =>
                                          //   handleDiscountChange(item)
                                          // }
                                          // type="radio"
                                          // id={item?.promotionName}

                                          checked={selectedDiscount?.some(
                                            (discount) =>
                                              discount.id === item.id
                                          )}
                                          onChange={() =>
                                            handleDiscountChange(item)
                                          }
                                          type="radio"
                                          id={item.promotionName}
                                        />
                                        <div>
                                          <div
                                            style={{
                                              color: selectedDiscount?.some(
                                                (discount) =>
                                                  discount.id === item.id
                                              )
                                                ? "#009A50"
                                                : "#333333",
                                            }}
                                          >
                                            {item?.promotionName?.replace(
                                              /-/g,
                                              " "
                                            )}
                                          </div>
                                        </div>
                                      </label>
                                    </div>
                                    <div>
                                      {item?.promotionMode === "fixed" ? (
                                        formatIndianCurrency(
                                          item?.promotionAmount
                                        )
                                      ) : (
                                        <>{item?.promotionAmount}%</>
                                      )}
                                    </div>
                                  </div>
                                )
                              );
                            })}

                            <div className="flex justify_content_end w-100 mt-10">
                              {selectedDiscount && (
                                <button
                                  className="view_btn"
                                  onClick={() => setSelectedDiscount([])}
                                >
                                  clear
                                </button>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                <div
                  className={styles.common_bg}
                  style={{
                    background: paymentDetails ? "#FFFCF3" : "#FFFFFF",
                  }}
                >
                  <div
                    className="flex justify_content_between pointer"
                    // onClick={togglePaymentDetails}
                    onClick={() => {
                      handleButtonClick();
                      togglePaymentDetails();
                    }}
                    style={{
                      borderBottom: "0.5px solid #cccccc7c",
                      paddingBottom: "10px",
                    }}
                  >
                    <h4 style={{ fontSize: "16px" }}>Price Breakup</h4>
                    <div>
                      <button
                        className={`${
                          activePayment === "priceSummary"
                            ? "cursor_pointer"
                            : "cursor_pointer"
                        }`}
                      >
                        {/* <small className="link_btn">
                                                    {" "}
                                                    View Full Breakup{" "}
                                                </small> */}
                        <svg
                          width="13"
                          height="8"
                          viewBox="0 0 13 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            transition: "transform 0.3s",
                            transform: paymentDetails
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          }}
                        >
                          <path
                            d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                            stroke="#222222"
                            strokeWidth="1.5"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  {activePayment !== "priceSummary" && !paymentDetails && (
                    <div>
                      <div className="flex justify_content_between mt-10">
                        <div>
                          Room Type
                          {/* ({bookingData?.room} R | {noOfNights} N ) */}
                        </div>
                        <div>{ratesData?.room_name}</div>
                      </div>
                      {/* <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                          <p>Room Rate</p>
                          <span className="room_text-right">
                            {formatIndianCurrency(selectedPlan?.rate_per_night)}
                          </span>
                        </div> */}

                      {/* {commission && commission?.commissionAmount && (
                          <div className="flex justify_content_between mt-10 ">
                            <p>
                              Commission Amount ({commission?.commissionType})
                            </p>
                            {commission.commissionType === "fixed" && (
                              <span className="room_text-right">
                                {formatIndianCurrency(
                                  commission?.commissionAmount
                                )}
                              </span>
                            )}
                          </div>
                        )} */}

                      <div className="flex justify_content_between align_items_center mt-10">
                        <div>
                          Room Rate <small>(Per Night)</small>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}
                        >
                          {/* {commission && Object.keys(commission).length > 0 && bookingValues?.roomRatePerNight && (
                              <small style={{ color: 'red', textDecoration: 'line-through' }}>
                                {formatIndianCurrency(bookingValues?.roomRatePerNight)}
                              </small>
                            )} */}

                          {formatIndianCurrency(bookingValues.newRoomRate)}
                        </div>
                      </div>

                      {/* {commission && commission?.commissionAmount && (
                          <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                            <p>Your Rate</p>
                            <span className="room_text-right">
                              {formatIndianCurrency(
                                bookingValues?.commissionRoomRate
                              )}
                            </span>
                          </div>
                        )} */}
                      {agentAdvanceCalculations.pay_with_company_credit && (
                        <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                          <div>Agent Credit</div>
                          <div>
                            -{" "}
                            {formatIndianCurrency(
                              agentAdvanceCalculations?.credit_balance -
                                agentAdvanceCalculations?.remaining_credit_balance
                            )}
                          </div>
                        </div>
                      )}

                      {agentAdvanceCalculations.pay_with_advance && (
                        <div className="flex justify_content_between mt-10 border-bottom-one p_b_10">
                          <div>Agent Advance</div>
                          <div>
                            -{" "}
                            {formatIndianCurrency(
                              agentAdvanceCalculations?.advanceLimit -
                                agentAdvanceCalculations?.remaining_advance_balance
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        className="flex justify_content_between mt-10 pt_10"
                        style={{ borderTop: ".5px solid #cccccc7c" }}
                      >
                        <h6>Total Amount to be paid</h6>
                        <h6>
                          {formatIndianCurrency(
                            agentAdvanceCalculations?.balanceAmount ||
                              agentAdvanceCalculations?.balanceAmount === 0
                              ? agentAdvanceCalculations?.balanceAmount
                              : bookingValues?.grandTotal
                          )}
                          {/* {formatIndianCurrency(agentAdvanceCalculations?.balanceAmount)} */}
                        </h6>
                      </div>
                    </div>
                  )}

                  {activePayment !== "priceDetails" && (
                    <div>
                      <div className="flex justify_content_between mt-10">
                        <div>
                          Room Type
                          {/* ({bookingData?.room} R | {noOfNights} N ) */}
                        </div>
                        <div className="text_right">{ratesData?.room_name}</div>
                      </div>

                      {(selectedAutomaticDiscount.length > 0 ||
                        selectedDiscount.length > 0) && (
                        <div className="mt-10">
                          <div
                            className="pt_10"
                            style={{ borderTop: "0.5px solid #cccccc7c" }}
                          >
                            <b>
                              Property Discount
                              {selectedAutomaticDiscount?.length > 1 ? "s" : ""}
                            </b>
                          </div>
                          {selectedAutomaticDiscount?.map((discount, index) => (
                            <div
                              className="flex justify_content_between mt-10"
                              key={discount.id}
                            >
                              <span className="discount-name">
                                {discount.promotionName}
                              </span>
                              <span className="room_text-right green">
                                {discount.promotionMode === "percentage"
                                  ? `${+discount.promotionAmount}%`
                                  : `${formatIndianCurrency(
                                      discount.promotionAmount
                                    )}`}
                              </span>
                            </div>
                          ))}

                          {selectedDiscount &&
                            selectedDiscount?.length > 0 &&
                            selectedDiscount?.map((discount, index) => (
                              <div
                                className="flex justify_content_between mt-2"
                                key={discount.id}
                              >
                                <span className="discount-name">
                                  {discount.promotionName}
                                </span>
                                <span>
                                  {discount.promotionMode === "percentage"
                                    ? `${+discount.promotionAmount}%`
                                    : `${formatIndianCurrency(
                                        discount.promotionAmount
                                      )}`}
                                </span>
                              </div>
                            ))}
                        </div>
                      )}

                      {/* {bookingValues?.discountAmt > 0 && (
                          <div className="flex justify_content_between mt-10">
                            <p>
                              Discount Amt.{" "}
                              <small> ({noOfNights} Nights)</small>
                            </p>
                            <span className="room_text-right">
                              {formatIndianCurrency(bookingValues?.discountAmt)}
                            </span>
                          </div>
                        )} */}

                      <div className="flex justify_content_between mt-10">
                        <div>
                          Room Rate <small>(Per Night)</small>
                        </div>
                        {/* <span className="room_text-right">
                            {formatIndianCurrency(bookingValues.newRoomRate)}
                          </span> */}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}
                        >
                          <div>
                            {" "}
                            {(selectedAutomaticDiscount.length > 0 ||
                              selectedDiscount.length > 0) &&
                              bookingValues.newRoomRate &&
                              bookingValues.roomRateAfterDiscount && (
                                <small
                                  style={{
                                    color: "red",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {formatIndianCurrency(
                                    bookingValues?.roomRatePerNight
                                  )}
                                </small>
                              )}
                          </div>

                          {formatIndianCurrency(
                            bookingValues.roomRateAfterDiscount
                              ? bookingValues.roomRateAfterDiscount
                              : bookingValues.newRoomRate
                          )}
                        </div>
                      </div>

                      {(bookingData?.room > 1 || noOfNights > 1) && (
                        <div className="flex justify_content_between mt-10">
                          <div>
                            {noOfNights} Night * {bookingData?.room} Rooms
                          </div>
                          <div>
                            {formatIndianCurrency(
                              bookingValues.roomRateAfterDiscount *
                                bookingData?.room *
                                noOfNights
                            )}
                          </div>
                        </div>
                      )}

                      {selectedPlan.extra_adult_count > 0 && (
                        <div className="flex justify_content_between mt-10">
                          <div>
                            {selectedPlan.extra_adult_count} Extra Adult{" "}
                            <small>
                              (
                              {/* {commission && Object.keys(commission).length > 0 && (
                                  <span style={{ color: 'red', textDecoration: 'line-through' }}>
                                    {formatIndianCurrency(
                                      bookingValues?.extraAdultPriceWithMarkup
                                    )}
                                    {" "}
                                  </span>
                                )} */}
                              {formatIndianCurrency(
                                bookingValues?.extraAdultPrice
                              )}{" "}
                              * {noOfNights} Night){" "}
                            </small>{" "}
                          </div>
                          <div>
                            {formatIndianCurrency(
                              bookingValues?.totalAdultCost
                            )}
                          </div>
                        </div>
                      )}

                      {/* {bookingValues?.childPrices > 0 && (
                          <div className="flex justify_content_between mt-10">
                            <p>
                              {bookingData.children} Extra Child{" "}
                              <small>
                                {" "}
                                ({formatIndianCurrency(
                                  bookingValues?.childPrices
                                )}{" "}
                                * {noOfNights} Night){" "}
                              </small>{" "}
                            </p>
                            <span className="room_text-right">
                              {formatIndianCurrency(
                                bookingValues?.totalChildAdultCost
                              )}
                            </span>
                          </div>
                        )} */}

                      {bookingValues?.childPrices > 0 && (
                        <div className="flex justify_content_between mt-10">
                          <div>
                            {extraChildrenForPricebreakup} Extra Child{" "}
                            <small>
                              {" "}
                              (
                              {formatIndianCurrency(
                                bookingValues?.childPrices
                              )}{" "}
                              * {noOfNights} Night){" "}
                            </small>{" "}
                          </div>
                          <div>
                            {formatIndianCurrency(
                              bookingValues?.totalChildAdultCost
                            )}
                          </div>
                        </div>
                      )}

                      {complimentaryChildren > 0 && (
                        <div className="flex justify_content_between mt-10">
                          <div>{complimentaryChildren} Complimentary Child</div>
                          <div>Free</div>
                        </div>
                      )}

                      {userDetails?.agent_category_discount && (
                        <div className="flex justify_content_between mt-10 green">
                          <div>
                            Discount % <small>(TAC)</small>
                          </div>
                          <div>
                            {Number(userDetails?.agent_category_discount)}%
                          </div>
                        </div>
                      )}
                      {/* {bookingValues?.discountAmt > 0 && (
                          <div className="flex justify_content_between mt-10">
                            <p>Discount Amt.</p>
                            <span className="room_text-right">
                              {formatIndianCurrency(bookingValues?.discountAmt)}
                            </span>
                          </div>
                        )} */}
                      {/* {bookingValues?.automaticDiscounts?.amount && (
                          <div className="flex justify_content_between mt-10 green">
                            <p>
                              Discount <small>(Automatic Discount)</small>
                            </p>
                            <span className="room_text-right green">
                              {bookingValues?.automaticDiscounts?.type ===
                                "percentage"
                                ? `${+bookingValues?.automaticDiscounts
                                  ?.amount}%`
                                : `${formatIndianCurrency(
                                  bookingValues?.automaticDiscounts?.amount
                                )}`}
                            </span>
                          </div>
                        )} */}

                      {/* {selectedDiscount &&
                          Object.keys(selectedDiscount).length > 0 && (
                            <div className="flex justify_content_between mt-10">
                              <p>Selected Discount</p>
                              <span className="room_text-right green">
                                {selectedDiscount?.promotionMode ===
                                  "percentage"
                                  ? `${+selectedDiscount?.promotionAmount}%`
                                  : `${formatIndianCurrency(
                                    selectedDiscount?.promotionAmount
                                  )}`}
                              </span>
                            </div>
                          )} */}

                      {/* <div className="flex justify_content_between mt-10">
                        <p>totalChildAdultCost</p>
                        <span className="room_text-right">
                          {formatIndianCurrency(bookingValues?.totalChildAdultCost)}
                          {formatIndianCurrency(bookingValues?.childPrices)}
                        </span>
                      </div> */}

                      {commission && commission?.commissionAmount && (
                        <div className="flex justify_content_between mt-10">
                          <div>
                            Commission{" "}
                            <small>
                              ({" "}
                              {commission.commissionType === "fixed" ? (
                                <span className="room_text-right">
                                  {formatIndianCurrency(
                                    commission?.commissionAmount
                                  )}
                                </span>
                              ) : (
                                <span className="room_text-right">
                                  {commission?.commissionAmount}%
                                </span>
                              )}
                              )
                            </small>
                          </div>
                          {formatIndianCurrency(
                            Number(bookingValues?.calculatedCommissionAmount)
                          )}
                          {/* {commission.commissionType === "fixed" ? (
                              <span className="room_text-right">
                                {formatIndianCurrency(
                                  commission?.commissionAmount
                                )}
                              </span>
                            ) : (
                              <span className="room_text-right">
                                {commission?.commissionAmount}%
                              </span>
                            )} */}
                        </div>
                      )}

                      {/* 
                        {commission && Object.keys(commission).length > 0 && bookingValues?.calculatedCommissionAmount && (
                          <div className="flex justify_content_between mt-10">
                            <p>
                              Your Savings
                            </p>
                            <span className="room_text-right">
                              {formatIndianCurrency(Number(bookingValues?.calculatedCommissionAmount))}
                            </span>
                          </div>
                        )} */}

                      <div
                        className="flex justify_content_between mt-10 pt_10"
                        style={{ borderTop: "0.5px solid #cccccc7c" }}
                      >
                        <div>Subtotal</div>
                        {/* <span className="room_text-right">
                            {formatIndianCurrency(bookingValues.subtotal)}
                          </span> */}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "end",
                          }}
                        >
                          {commission &&
                            Object.keys(commission).length > 0 &&
                            bookingValues?.calculatedCommissionAmount && (
                              <small
                                style={{
                                  color: "red",
                                  textDecoration: "line-through",
                                }}
                              >
                                {formatIndianCurrency(
                                  Number(bookingValues?.subtotal) +
                                    Number(
                                      bookingValues?.calculatedCommissionAmount
                                    )
                                )}
                              </small>
                            )}
                          {formatIndianCurrency(bookingValues?.subtotal)}
                        </div>
                      </div>

                      <div className="flex justify_content_between mt-10">
                        <div>Tax Amount ({bookingValues?.taxSlab}%)</div>
                        <div>
                          {formatIndianCurrency(bookingValues.taxAmount)}
                        </div>
                      </div>

                      {agentAdvanceCalculations.pay_with_company_credit && (
                        <div className="flex mt-10 justify_content_between p_b_10">
                          <div>Agent Credit</div>
                          <div>
                            -{" "}
                            {formatIndianCurrency(
                              agentAdvanceCalculations?.credit_balance -
                                agentAdvanceCalculations?.remaining_credit_balance
                            )}
                          </div>
                        </div>
                      )}

                      {agentAdvanceCalculations.pay_with_advance && (
                        <div className="flex justify_content_between border-bottom-one p_b_10">
                          <div>Agent Advance</div>
                          <div>
                            -{" "}
                            {formatIndianCurrency(
                              agentAdvanceCalculations?.advanceLimit -
                                agentAdvanceCalculations?.remaining_advance_balance
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        className="flex justify_content_between mt-10 pt_10"
                        style={{ borderTop: "0.5px solid #cccccc7c" }}
                      >
                        <h6>Grand Total</h6>
                        <h6>
                          {formatIndianCurrency(
                            agentAdvanceCalculations?.balanceAmount ||
                              agentAdvanceCalculations?.balanceAmount === 0
                              ? agentAdvanceCalculations?.balanceAmount
                              : bookingValues?.grandTotal
                          )}
                        </h6>
                      </div>
                    </div>
                  )}
                </div>
                {payNow && (
                  <div className="paynow_amount_main">
                    <div className="flex justify_content_between">
                      <span className={`${styles.common_head_h5}`}>
                        Pay at Hotel
                      </span>
                      <span className={`${styles.common_head_h5}`}>
                        {" "}
                        {formatIndianCurrency(
                          payNow
                            ? (PayAmount - payNowAmount).toFixed(2)
                            : PayAmount.toFixed(2)
                        )}
                      </span>
                    </div>
                    <div className="flex justify_content_between pt_10">
                      <span className={`${styles.common_head_h5}`}>
                        <strong>Pay Now</strong>
                      </span>
                      <span className={`${styles.common_head_h5}`}>
                        <strong>
                          {formatIndianCurrency(
                            payNow ? +payNowAmount.toFixed(2) : 0
                          )}
                        </strong>
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* <NewFooterUI /> */}
        <CheckoutFooter />
        <div className={styles.mobile_price_breakup}>
          <div>
            <div>Grand Total</div>
            <h6>
              <b>
                {formatIndianCurrency(
                  agentAdvanceCalculations?.balanceAmount ||
                    agentAdvanceCalculations?.balanceAmount === 0
                    ? agentAdvanceCalculations?.balanceAmount
                    : bookingValues?.grandTotal
                )}
              </b>
            </h6>
          </div>
          <button className={styles.book_btn} onClick={handleSubmit}>
            Proceed to Payment
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_6067_16102"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="17"
                height="17"
              >
                <rect x="0.5" y="0.5" width="16" height="16" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6067_16102)">
                <path
                  d="M11.2837 9.16674H3.83366C3.64477 9.16674 3.48644 9.10285 3.35866 8.97507C3.23088 8.8473 3.16699 8.68896 3.16699 8.50007C3.16699 8.31118 3.23088 8.15285 3.35866 8.02507C3.48644 7.89729 3.64477 7.83341 3.83366 7.83341H11.2837L8.01699 4.56674C7.88366 4.43341 7.81977 4.27785 7.82533 4.10007C7.83088 3.9223 7.90033 3.76674 8.03366 3.63341C8.16699 3.51118 8.32255 3.4473 8.50033 3.44174C8.6781 3.43618 8.83366 3.50007 8.96699 3.63341L13.367 8.03341C13.4337 8.10007 13.4809 8.1723 13.5087 8.25007C13.5364 8.32785 13.5503 8.41118 13.5503 8.50007C13.5503 8.58896 13.5364 8.6723 13.5087 8.75007C13.4809 8.82785 13.4337 8.90007 13.367 8.96674L8.96699 13.3667C8.84477 13.489 8.69199 13.5501 8.50866 13.5501C8.32533 13.5501 8.16699 13.489 8.03366 13.3667C7.90033 13.2334 7.83366 13.0751 7.83366 12.8917C7.83366 12.7084 7.90033 12.5501 8.03366 12.4167L11.2837 9.16674Z"
                  fill="white"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
}

export default NewUICheckoutHotel;

// <div className="list_details p_0">
// <div
//     className="flex justify_content_between p_20 cursor_pointer align_items_center"
//     onClick={toggleGuestDetails}
//     id="padding"
// >
//     <h5 className="text-left">GUEST DETAILS</h5>
//     <svg
//         width="13"
//         height="8"
//         viewBox="0 0 13 8"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         style={{
//             transition: "transform 0.3s",
//             transform: guestDetails
//                 ? "rotate(180deg)"
//                 : "rotate(0deg)",
//         }}
//     >
//         <path
//             d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
//             stroke="#222222"
//             strokeWidth="1.5"
//         />
//     </svg>
// </div>
// {guestDetails && (
//     <>
//         <form action="">
//             <div
//                 className="p_20 p_top_0 border-bottom-one"
//                 id="padding"
//             >
//                 <div className="input-flex">
//                     <div className="HotelCheckout-form w-half">
//                         <label htmlFor="">Full Name</label>
//                         <input
//                             className="HotelCheckout-Input"
//                             id="guest_name"
//                             type="text"
//                             name="guest_name"
//                             value={guestData.guest_name}
//                             onChange={guestDataHandleChange}
//                             style={
//                                 formErrors.guest_name && {
//                                     backgroundColor: "#ff000040",
//                                     border: "1px solid red",
//                                 }
//                             }
//                             placeholder="Name"
//                         />
//                     </div>
//                     <div className="CheckoutHotel-Fields w-half">
//                         <label htmlFor="">Phone</label>
//                         <input
//                             className="HotelCheckout-Input"
//                             type="number"
//                             id="guest_phone"
//                             name="guest_phone"
//                             value={guestData.guest_phone}
//                             onChange={guestDataHandleChange}
//                             style={
//                                 formErrors.guest_phone && {
//                                     backgroundColor: "#ff000040",
//                                     border: "1px solid red",
//                                 }
//                             }
//                             placeholder="Phone"
//                         />
//                     </div>
//                 </div>

//                 <div className="input-flex">
//                     <div className="CheckoutHotel-Fields w-half">
//                         <label htmlFor="">
//                             Email Address{" "}
//                             {/* <small>
// (Booking voucher will be sent to this email
// ID)
// </small> */}
//                         </label>
//                         <input
//                             className="HotelCheckout-Input"
//                             id="guest_email"
//                             name="guest_email"
//                             value={guestData.guest_email}
//                             onChange={guestDataHandleChange}
//                             style={
//                                 formErrors.guest_email && {
//                                     backgroundColor: "#ff000040",
//                                     border: "1px solid red",
//                                 }
//                             }
//                             placeholder="Email"
//                         />
//                     </div>
//                     <div className="CheckoutHotel-Fields w-half">
//                         <label htmlFor="">Zipcode</label>
//                         <input
//                             className="HotelCheckout-Input"
//                             type="number"
//                             id="zipcode"
//                             name="zipcode"
//                             value={guestData.zipcode}
//                             onChange={guestDataHandleChange}
//                             style={
//                                 formErrors.zipcode && {
//                                     backgroundColor: "#ff000040",
//                                     border: "1px solid red",
//                                 }
//                             }
//                             placeholder="Zipcode"
//                         />
//                     </div>
//                 </div>

//                 <div className="mt-10">
//                     <label htmlFor="address">Address</label>
//                     <AddressAutocomplete
//                         formdata={formData}
//                         onAddressChange={handleAddressData}
//                     />
//                 </div>

//                 <div className="mt-5">
//                     <label htmlFor="">Additional Details</label>
//                     <textarea
//                         className="HotelCheckout-Input"
//                         id="accommodation_notes_information"
//                         name="accommodation_notes_information"
//                         value={guestData.accommodation_notes_information}
//                         onChange={guestDataHandleChange}
//                         required
//                         placeholder="Additional Details"
//                     />
//                 </div>
//             </div>
//         </form>
//         {/* <div
// onClick={toggleBusinessProfile}
// className="p_20 flex_align_center flex_gap_10"
// id="padding"
// >
// <input
// type="checkbox"
// className="cursor_pointer"
// checked={businessProfile}
// />
// <div className="cursor_pointer">
// Enter GST Details
// <small> (Optional)</small>
// </div>
// </div>
// {businessProfile && (
// <form onSubmit={handleSubmit}>
// <div className="p_20 p_top_0" id="padding">
// <h5 className="text-left">BUSINESS PROFILE</h5>
// <div className="input-flex mt-10">
// <div>
// <input
// className="w-full"
// id="gst_number"
// name="gst_number"
// value={guestData.gst_number}
// onChange={guestDataHandleChange}
// style={
// formErrors.gst_number && {
//   backgroundColor: "#ff000040",
//   border: "1px solid red",
// }
// }
// placeholder="GST Number"
// />
// </div>
// <div>
// <input
// className="w-full"
// id="business_email"
// name="business_email"
// value={guestData.business_email}
// onChange={guestDataHandleChange}
// style={
// formErrors.business_email && {
//   backgroundColor: "#ff000040",
//   border: "1px solid red",
// }
// }
// placeholder="Business Email ID"
// />
// </div>
// </div>
// <div className="input-flex">
// <div>
// <input
// className="w-full"
// id="company_number"
// type="number"
// name="company_number"
// value={guestData.company_number}
// onChange={guestDataHandleChange}
// style={
// formErrors.company_number && {
//   backgroundColor: "#ff000040",
//   border: "1px solid red",
// }
// }
// placeholder="Company Phone Number"
// />
// </div>
// </div>
// </div>
// </form>
// )} */}

//         {/* {userType === "agent" && (
// <>
// <div
// onClick={() =>
// setPayWithAgentCredit(!payWithAgentCredit)
// }
// className="px_20 flex_align_center flex_gap_10"
// id="padding"
// >
// <input
// type="checkbox"
// className="cursor_pointer"
// checked={payWithAgentCredit}
// />
// <div className="cursor_pointer">
// Pay With Agent Credits
// <small>
// {" "}
// (
// {formatIndianCurrency(
// agentAdvanceCalculations?.remaining_credit_balance
// )}
// )
// </small>
// </div>
// </div>
// <div
// onClick={() => setPayWithAdvance(!payWithAdvance)}
// className="p_20 flex_align_center flex_gap_10"
// id="padding"
// >
// <input
// type="checkbox"
// className="cursor_pointer"
// checked={payWithAdvance}
// />
// <div className="cursor_pointer">
// Pay With Advance Amount
// <small>
// {" "}
// (
// {formatIndianCurrency(
// agentAdvanceCalculations?.remaining_advance_balance
// )}
// )
// </small>
// </div>
// </div>
// </>
// )} */}
//     </>
// )}
// </div>
{
  /* {!userDetails && !userToken && (
                    <>
                      <p style={{ textAlign: 'center', margin: '5px 0' }}>or</p>
                      <GoogleLogin
                        onSuccess={handleSuccessLoginWithGoogle}
                        onError={() => showErrorToast('Login Failed')}
                      />
                    </>
                  )} */
}
